<template>
  <!-- 项目申报 -->
  <div class="proReport">
    <div class="title f-r j-b">
      <span>服务商申报</span>
      <span class="back" @click="back">返回申报列表</span>
    </div>
    <div class="report">
      <!-- 步骤条 -->
      <div class="apply-step">
        <el-steps :active="activeStep" align-center>
          <el-step
            :description="item.label"
            v-for="(item, index) in stepsList"
            :key="index"
            @click.native="onClickStep(index)"
          >
            <!-- <span slot="title">
                            <img :src="bindTitleIcon(index)" width="55" alt="" />
            </span>-->
            <div slot="icon">
              <!-- <img :src="(index === activeStep - 1) ? timeLineSelectIcon : timeLineNormalIcon" width="28"
              alt="" />-->
              <div :class="(index < activeStep - 1) ? 'stepCur' : ''">{{ index + 1 }}</div>
            </div>
          </el-step>
        </el-steps>
      </div>
      <!-- 申报表单 -->
      <div class="apply-form">
        <el-form
          v-show="activeStep == '1'"
          ref="form"
          :model="form"
          :rules="rules"
          label-width="165px"
          class="form-wrap"
          :disabled="disabled"
        >
          <div class="form-title">企业信息</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申报单位名称：" prop="unitName">
                <el-input v-model="form.unitName" placeholder="请输入" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="法人代表：" prop="legalPerson">
                <el-input v-model="form.legalPerson" placeholder="请输入" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="社会统一信用代码：" prop="creditCode">
                <el-input v-model="form.creditCode" placeholder="请输入" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位性质：" prop="type">
                <el-select v-model="form.type" placeholder="请选择" clearable>
                  <el-option
                      v-for="item in natureList"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          <el-col :span="8">
            <el-form-item label="成立时间" prop="establishTime">
              <el-date-picker
                  v-model="form.establishTime"
                  type="date"
                  style="width: 100%;"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择生产日期"
                  disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业规模：" prop="scale">
              <el-select v-model="form.scale" placeholder="请选择" clearable>
                <el-option
                    v-for="item in scaleList"
                    :key="item.uuid"
                    :label="item.name"
                    :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
            <el-col :span="8">
              <el-form-item label="注册资金：" prop="registerMoney">
                <el-input v-model="form.registerMoney" placeholder="请输入" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人：" prop="contact">
                <el-input v-model="form.contact" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话：" prop="telPhone">
                <el-input v-model="form.telPhone" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人职务：" prop="contactDuty">
                <el-input v-model="form.contactDuty" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系邮箱：" prop="email">
                <el-input v-model="form.email" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位地址：" prop="address">
                <el-input v-model="form.address" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="宁夏分支机构所在地（区外公司填写）：" prop="branchOffice" class="long-label">
                <el-input v-model="form.branchOffice" placeholder="宁夏分支机构所在地" clearable />
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="主营业务：" prop="mainBusiness">-->
<!--                <el-input v-model="form.mainBusiness" placeholder="请输入" clearable />-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="12">
              <el-form-item label="近三年主营业务收入（万元）：" prop="incomeYear1" class="long-label">
                <el-row>
                  <el-col :span="8">
                    <el-input type="number" v-model="form.incomeYear1" :placeholder="(new Date().getFullYear()-3).toString()" clearable />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="number"v-model="form.incomeYear2" :placeholder="(new Date().getFullYear()-2).toString()" clearable />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="number" v-model="form.incomeYear3" :placeholder="(new Date().getFullYear()-1).toString()" clearable />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="研发投入占主营业务收入比重（%）：" prop="inputRatioYear1"  class="long-label">
                <el-row>
                  <el-col :span="8">
                    <el-input type="number"v-model="form.inputRatioYear1" :placeholder="(new Date().getFullYear()-3).toString()" clearable />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="number" v-model="form.inputRatioYear2" :placeholder="(new Date().getFullYear()-2).toString()" clearable />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="number" v-model="form.inputRatioYear3" :placeholder="(new Date().getFullYear()-1).toString()" clearable />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-title">服务信息</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申报方向：" prop="direction">
                <el-select v-model="form.direction" placeholder="请选择" clearable>
                  <el-option
                      v-for="item in directionList"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="主要服务的重点行业：" prop="serviceIndustry">
                <el-select v-model="form.serviceIndustry" placeholder="请选择" clearable multiple>
                  <el-option
                      v-for="item in industryList"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="主要服务的产业：" prop="serviceIndustryDetail">
                <el-select v-model="form.serviceIndustryDetail" placeholder="请选择" clearable multiple>
                  <el-option
                      v-for="item in sectorList"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 动态表格：近三年在主要产业开展数字化转型服务企业数量及合同总金额 -->
<!--            <div class="form-title">*近三年在主要产业开展数字化转型服务企业数量及合同总金额</div>-->
<!--            v-if="form.serviceIndustryDetail && form.serviceIndustryDetail.length > 0"-->
            <div >
              <table border="1" style="width: 100%; border-collapse: collapse; margin-bottom: 20px;font-size: 14px;">
                <thead>
                <tr style="background-color: rgb(250, 250, 250); color: #333;height: 50px">
                  <th colspan="5" style="width: 100%; text-align: center;">近三年在主要产业开展数字化转型服务企业数量及合同总金额</th>
                </tr>
                <tr style="background-color: rgb(250, 250, 250); color: #333;height: 30px">
                  <th style="width: 100px; text-align: center;">产业</th>
                  <th style="width: 200px; text-align: center;">服务企业数量</th>
                  <th style="width: 200px; text-align: center;">其中服务宁夏企业数量</th>
                  <th style="width: 200px; text-align: center;">合同总金额(万元)</th>
                  <th style="width: 200px; text-align: center;">其中宁夏企业合同总金额(万元)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(industry, index) in form.serviceIndustryDetail" :key="index">
                  <td style="text-align: center; background-color: rgb(250, 250, 250); font-weight: bold;">{{ industry }}</td>
                  <td>
                    <el-input type="number" class="center-input" v-model="serviceEnterpriseInfoList[index].serviceEnterpriseNum" placeholder="请输入" clearable />
                  </td>
                  <td>
                    <el-input type="number" class="center-input" v-model="serviceEnterpriseInfoList[index].serviceNxEnterpriseNum" placeholder="请输入" clearable />
                  </td>
                  <td>
                    <el-input type="number" class="center-input" v-model="serviceEnterpriseInfoList[index].contractMoney" placeholder="请输入" clearable />
                  </td>
                  <td>
                    <el-input type="number" class="center-input" v-model="serviceEnterpriseInfoList[index].serviceNxContractMoney" placeholder="请输入" clearable />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- 技术能力表格（原生 table） -->
<!--            <div class="form-title">*技术能力</div>-->
            <table border="1" style="width: 100%; border-collapse: collapse;font-size: 14px;">
              <thead>
              <tr style="background-color: rgb(250, 250, 250); color: #333;height: 50px">
                <th colspan="6" style="width: 100%; text-align: center;">技术能力</th>
              </tr>
              <tr style="background-color: rgb(250, 250, 250); color: #333;height: 30px">
                <th style="width: 200px; text-align: center;">企业员工总数(人)</th>
                <th style="width: 200px; text-align: center;">研发人员(人)</th>
                <th style="width: 200px; text-align: center;">硕士(人)</th>
                <th style="width: 200px; text-align: center;">博士(人)</th>
                <th style="width: 200px; text-align: center;">中级职称(人)</th>
                <th style="width: 200px; text-align: center;">高级职称(人)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><el-input type="number" class="center-input" v-model="form.employeeNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.rdNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.masterNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.doctorNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.middleTitleNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.highTitleNum" placeholder="请输入" clearable /></td>
              </tr>
              </tbody>
            </table>

            <table border="1" style="width: 100%; border-collapse: collapse;font-size: 14px;">
              <thead>
              <tr style="background-color: rgb(250, 250, 250); color: #333;height: 30px">
                <th style="width: 400px; text-align: center;">核心业务领域专利累计授权(件)</th>
                <th style="width: 400px; text-align: center;">发明专利(件)</th>
                <th style="width: 400px; text-align: center;">核心业务领域计算机软件著作权累计登记(件)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><el-input type="number" class="center-input" v-model="form.patentNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.inventionNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.softwareNum" placeholder="请输入" clearable /></td>
              </tr>
              </tbody>
            </table>

            <table border="1" style="width: 100%; border-collapse: collapse; font-size: 14px;">
              <thead>
              <tr style="background-color: rgb(250, 250, 250); color: #333;height: 30px">
                <th style="width: 400px; text-align: center;">牵头制定的数字化转型领域国家标准(项)</th>
                <th style="width: 400px; text-align: center;">行业标准(项)</th>
                <th style="width: 400px; text-align: center;">团体标准(项)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><el-input type="number" class="center-input" v-model="form.leadStandardNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.industryStandardNumOther" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.groupStandardNumOther" placeholder="请输入" clearable /></td>
              </tr>


              </tbody>
            </table>
            <table border="1" style="width: 100%; border-collapse: collapse;font-size: 14px;margin-bottom: 20px;">
              <thead>
              <tr style="background-color: rgb(250, 250, 250); color: #333;height: 30px">
                <th style="width: 400px; text-align: center;">参与制定的数字化转型领域国家标准(项)</th>
                <th style="width: 400px; text-align: center;">行业标准(项)</th>
                <th style="width: 400px; text-align: center;">团体标准(项)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><el-input type="number" class="center-input" v-model="form.nationalStandardNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.industryStandardNum" placeholder="请输入" clearable /></td>
                <td><el-input type="number" class="center-input" v-model="form.groupStandardNum" placeholder="请输入" clearable /></td>
              </tr>
              <tr style="background-color: rgb(250, 250, 250); color: #333;">
                <th style="width: 400px; text-align: center;">资质类型</th>
                <td colspan="2"><el-select v-model="form.qualificationType" placeholder="请选择" clearable multiple>
                  <el-option
                      v-for="item in qualificationList"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.name"
                  ></el-option>
                </el-select></td>
              </tr>
              <tr style="background-color: rgb(250, 250, 250); color: #333;">
                <th style="width: 400px; text-align: center;">其他资质说明</th>
                <td colspan="2">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.otherQualification" placeholder="请输入" clearable />
                </td>
              </tr>
              </tbody>
            </table>

          </el-row>
          <el-row>
            <el-col :span="24">
<!--              <el-form-item label="资质类型：" prop="qualificationType">-->
<!--                <el-select v-model="form.qualificationType" placeholder="请选择" clearable multiple>-->
<!--                  <el-option-->
<!--                      v-for="item in qualificationList"-->
<!--                      :key="item.uuid"-->
<!--                      :label="item.name"-->
<!--                      :value="item.name"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-col :span="24">-->
<!--                <el-form-item label="其他资质说明：" prop="otherQualification">-->
<!--                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.otherQualification" placeholder="请输入" clearable />-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="24">
                <el-form-item label="近三年获得相关荣誉：" prop="honor">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 4}" v-model="form.honor" placeholder="请输入" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业基本情况：" prop="introduction">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 50}" v-model="form.introduction" placeholder="填写注册信息、主营业务及核心客户等" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="核心技术与竞争优势：" prop="competitiveAdvantage">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 50}" v-model="form.competitiveAdvantage" placeholder="请输入" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业数字化工程项目实施能力："t prop="digitalFactoryCapability" class="long-label">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 50}" v-model="form.digitalFactoryCapability" placeholder="请输入" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="主要服务内容及辐射区域：" prop="serviceContent" class="long-label">
                  <el-input type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 2, maxRows: 50}" v-model="form.serviceContent" placeholder="请输入" clearable />
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>

        </el-form>
        <teamInfo v-show="activeStep == '2'" ref="secondStep" :uuid="uuid" />
        <productInfo v-show="activeStep == '3'" ref="thirdStep" :uuid="uuid" />
        <caseInfo v-show="activeStep == '4'" ref="fourthStep" :uuid="uuid" />
        <attachInfo v-if="activeStep == '5'" ref="fifthStep" :uuid="uuid" :licenseUrl="licenseUrl" />
        <h4 v-if="showDeclare">审核流程</h4>
        <div v-if="showDeclare" class="process">
          <div v-for="(item, index) in flowList" :key="index" class="f-r j-b a-c">
            <span>{{ index + 1 }}. {{ item.audit }}审核：{{ item.content }}</span>
            <span>{{ item.status | getStatus }} {{ item.auditTime }}</span>
          </div>
        </div>
        <div class="btnGroup f-r j-c a-c">
          <div class="form-pre" @click="back">关闭</div>
          <div v-show="activeStep > 1" class="form-pre" @click="activeStep--">上一步</div>
          <div
              v-show="!disabled"
              class="form-next"
              @click="save()"
          >保存</div>
          <div v-show="activeStep < 5" class="form-next" @click="save()">下一步</div>
          <div v-show="activeStep == 5 && !disabled" class="form-next" @click="submit">提交</div>
<!--          <div-->
<!--            v-show="activeStep == 5 && !disabled"-->
<!--            class="form-pre"-->
<!--            style="background-color:#fff"-->
<!--            @click="save()"-->
<!--          >保存</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurrentInfo,
  saveServiceProviderCompanyInfo,
  getServiceProviderCompanyInfo,
  getIndexDictionaryData,
  verifyFlowPath
} from "../../utils/interface";
import ningxia from "../../utils/ningxia";
import teamInfo from "./teamInfo.vue";
import productInfo from "./productInfo.vue";
import caseInfo from "./caseInfo.vue";
import attachInfo from "./attachInfo";
const form = () => {
  return {
    rdNum: "", // 研发人数
    employeeNum: "", // 员工数量
    masterNum: "", // 硕士人数
    doctorNum: "", // 博士人数
    middleTitleNum: "", // 中级职称人数
    highTitleNum: "", // 高级职称人数
    patentNum: "", // 发明专利数
    inventionNum:"",
    softwareNum:"",
    unitName: "", // 申报单位名称
    legalPerson: "", // 法人
    creditCode: "", // 统一信用代码
    telPhone: "", // 联系电话
    email: "",
    type: "", // 单位性质
    establishTime: "", // 成立时间
    scale: "", // 单位规模
    registerMoney: "", // 注册资本
    address: "", // 申报单位地址
    nature: "", // 单位性质
    regionValue: "", // 所在省 市 县
    companyProvice: "", // 企业所在省
    companyCity: "", // 企业所在市
    companyArea: "", // 企业所在区
    companyCode: "", // 企业编码
    contact: "", // 联系人
    branchOffice: "", // 宁夏分支机构所在地（区外公司填写）
    mainBusiness: "", // 主营业务
    contactTel: "", // 联系人电话
    contactDuty: "", // 联系人职务
    incomeYear1: "", // 近三年主营业务收入（万元）-第一年
    incomeYear2: "", // 近三年主营业务收入（万元）-第二年
    incomeYear3: "", // 近三年主营业务收入（万元）-第三年
    inputRatioYear1: "", // 研发投入占主营业务收入比重（%）-第一年
    inputRatioYear2: "", // 研发投入占主营业务收入比重（%）-第二年
    inputRatioYear3: "", // 研发投入占主营业务收入比重（%）-第三年
    direction: "", // 申报方向
    serviceIndustry: "", // 服务行业
    serviceIndustryDetail: [], // 服务行业详细
    nationalStandardNum: "", // 参与制定的数字化转型领域国家标准
    industryStandardNum: "", // 行业标准
    groupStandardNum: "", // 团体标准
    leadStandardNum: "", // 牵头制定的数字化转型领域国家标准
    industryStandardNumOther: "", // 牵头行业标准
    groupStandardNumOther: "", // 牵头团体标准
    qualificationType: [], // 资质类型
    otherQualification: "", // 其他资质
    honor: "", // 荣誉
    competitiveAdvantage: "", // 核心技术与竞争优势
    introduction:"",
    digitalFactoryCapability: "", // 企业数字化工程项目实施能力
    serviceContent: "", // 主要服务内容及辐射区域
    lastProfit: "", // 上一年利润
    lastTax: "", // 上一年交税
    currentRevenue: "", // 今年营收
    currentProfit: "", // 今年利润
    currentTax: "", // 今年交税
    evaluate: "", // 评估报告 文件上传后返回的地址
    evaluateScore: "", // 评估分数
    evaluateName: "", // 评估名称
    fusion: "", // 两化融合报告
    fusionScore: "", // 两化融合报告分数
    fusionName: "" // 两化融合报告名称
  };
};
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const rules = () => {
  return {
    unitName: [
      { required: true, message: "请输入申报单位名称", trigger: ["blur", "change"] }
    ],
    address: [
      { required: true, message: "请输入申报单位地址", trigger: ["blur", "change"] }
    ],
    legalPerson: [{ required: true, message: "请输入法人", trigger: "blur" }],
    creditCode: [{ required: true, message: "请输入统一信用代码", trigger: "blur" }],
    type: [
      { required: true, message: "请选择单位性质", trigger: "change" }
    ],
    establishTime: [{ required: true, message: "请选择成立时间", trigger: "change" }],
    scale: [
      { required: true, message: "请选择单位规模", trigger: "change" }
    ],
    registerMoney: [{ required: true, message: "请输入注册资本", trigger: "blur" }],
    contact: [
      { required: true, message: "请输入联系人", trigger: "blur" }
    ],
    telPhone: [
      { required: true, message: "请输入联系电话", trigger: "blur" }
    ],
    contactDuty: [
      { required: true, message: "请输入联系人职务", trigger: "blur" }
    ],
    email: [
      { required: true, message: "请输入联系邮箱", trigger: "blur" }
    ],
    // branchOffice: [
    //   { required: true, message: "请输入宁夏分支机构所在地", trigger: "blur" }
    // ],
    // mainBusiness: [
    //   { required: true, message: "请输入主营业务", trigger: "blur" }
    // ],
    incomeYear1: [
      { required: true, message: "请输入主营业务收入", trigger: "blur" }
    ],
    incomeYear2: [
      { required: true, message: "请输入主营业务收入", trigger: "blur" }
    ],
    incomeYear3: [
      { required: true, message: "请输入主营业务收入", trigger: "blur" }
    ],
    inputRatioYear1: [
      { required: true, message: "请输入研发投入占比", trigger: "blur" }
    ],
    inputRatioYear2: [
      { required: true, message: "请输入研发投入占比", trigger: "blur" }
    ],
    inputRatioYear3: [
      { required: true, message: "请输入研发投入占比", trigger: "blur" }
    ],
    direction: [
      { required: true, message: "请选择申报方向", trigger: "change" }
    ],
    // serviceIndustry: [
    //   { required: true, message: "请选择主要服务的重点行业", trigger: "change" }
    // ],
    serviceIndustryDetail: [
      { required: true, message: "请选择主要服务的产业", trigger: "change" }
    ],
    employeeNum: [
      { required: true, message: "请输入企业员工总数", trigger: "blur" }
    ],
    masterNum: [
      { required: true, message: "请输入硕士人数", trigger: "blur" }
    ],
    doctorNum: [
      { required: true, message: "请输入博士人数", trigger: "blur" }
    ],
    middleTitleNum: [
      { required: true, message: "请输入中级职称人数", trigger: "blur" }
    ],
    highTitleNum: [
      { required: true, message: "请输入高级职称人数", trigger: "blur" }
    ],
    patentNum: [
      { required: true, message: "请输入核心业务领域专利累计授权", trigger: "blur" }
    ],
    inventionNum: [
      { required: true, message: "请输入发明专利数", trigger: "blur" }
    ],
    softwareNum: [
      { required: true, message: "请输入核心业务领域计算机软件著作权累计登记", trigger: "blur" }
    ],
    nationalStandardNum: [
      { required: true, message: "请输入参与制定的数字化转型领域国家标准", trigger: "blur" }
    ],
    industryStandardNum: [
      { required: true, message: "请输入行业标准数", trigger: "blur" }
    ],
    groupStandardNum: [
      { required: true, message: "请输入团体标准数", trigger: "blur" }
    ],
    qualificationType: [
      { required: true, message: "请选择资质类型", trigger: "change" }
    ],
    // otherQualification: [
    //   { required: true, message: "请输入其他资质说明", trigger: "blur" }
    // ],
    honor: [
      { required: true, message: "请输入近三年获得相关荣誉", trigger: "blur" }
    ],
    competitiveAdvantage: [
      { required: true, message: "请输入核心技术与竞争优势", trigger: "blur" }
    ],
    introduction: [
      { required: true, message: "请输入企业基本情况", trigger: "blur" }
    ],
    digitalFactoryCapability: [
      { required: true, message: "请输入企业数字化工程项目实施能力", trigger: "blur" }
    ],
    serviceContent: [
      { required: true, message: "请输入主要服务内容及辐射区域", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: { teamInfo, productInfo, caseInfo,attachInfo },
  props: {},
  data() {
    return {
      headerBgUrl: require("../../assets/publicService/home/1.png"),
      stepsList: [
        { label: "单位概括" },
        { label: "核心团队" },
        { label: "产品及解决方案" },
        { label: "典型案例" },
        { label: "证明材料" }
      ],
      activeStep: 1,
      natureList:[],
      directionList: [],
      industryList: [],
      // 产业列表
      sectorList: [],
      qualificationList: [],
      form: form(),
      serviceIndustryDetail:[],
      rules: rules(),
      scaleList:[],
      regionOptions: ningxia,
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      flowList: [], // 审核流程
      serviceEnterpriseInfoList:[],
      uuid: "", // 项目id
      licenseUrl: "", // 申报单位营业执照
      disabled: false, // 根据status判断：INIT——待提交、REVIEW——审核中、REVIEW_PASS——审核通过、REJECT——驳回
      showFile1: false, // 详情或可修改状态时（INIT）为true展示
      showFile2: false,
      showDeclare: false // 是否展示审核流程，只有审核状态是通过、未通过、审核中的可以展示
    };
  },
  filters: {
    getStatus(val) {
      if (val) {
        return val == "REJECT" ? "驳回" : "审核通过";
      } else {
        return;
      }
    }
  },
  computed: {},
  watch: {
    // 监听主要服务的产业字段变化，动态生成表格数据
    // 修改 watch 中的 'form.serviceIndustryDetail' 处理逻辑
    'form.serviceIndustryDetail': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          // 创建新的服务企业信息列表，只包含当前选中的产业
          const newServiceEnterpriseInfoList = newVal.map(industry => {
            // 查找是否已有该产业的数据
            const existingItem = this.serviceEnterpriseInfoList.find(item => item.industryType === industry);
           console.log("existingItem",this.serviceEnterpriseInfoList,existingItem);
            if (existingItem) {
              return existingItem;
            } else {
              // 如果没有则创建新项
              return {
                industryType:industry,
                serviceEnterpriseNum: '',
                serviceNxEnterpriseNum: '',
                contractMoney: '',
                serviceNxContractMoney: ''
              };
            }
          });

          // 更新 serviceEnterpriseInfoList
          this.serviceEnterpriseInfoList = newServiceEnterpriseInfoList;
        } else {
          this.serviceEnterpriseInfoList = [];
        }
      },
      immediate: true
    }

  },
  created() {},
  mounted() {
    this.getCompanyType();
    if (this.$route.query.uuid) {
      // console.log('第一步')
      // 如果是查看申报详情进来
      this.getServiceProviderCompanyInfo(this.$route.query.uuid);
    } else {
      // 点击申报进来
      // this.getCurrentInfo();
    }
    this.getCurrentInfo();
    if (
      this.$route.query.status == "REVIEW" ||
      this.$route.query.status == "REVIEW_PASS" ||
      this.$route.query.status == "REJECT"
    ) {
      this.showDeclare = true;
    }
  },
  methods: {
    /* 获取企业性质、企业规模、第一产业下行业、第二产业下行业、第三产业下行业 */
    getCompanyType() {
      getIndexDictionaryData({
        groupCode: "enterprise_type_standard"
      }).then(res => {
        this.natureList = res;
      });
      getIndexDictionaryData({
        groupCode: "enterprise_scale"
      }).then(res => {
        this.scaleList = res;
      });
      getIndexDictionaryData({
        groupCode: "enterprise_direction"
      }).then(res => {
        this.directionList = res;
      });
      getIndexDictionaryData({
        groupCode: "service_provider_industry"
      }).then(res => {
        this.industryList = res;
      });
      getIndexDictionaryData({
        groupCode: "service_provider_sector"
      }).then(res => {
        this.sectorList = res;
      });
      getIndexDictionaryData({
        groupCode: "service_provider_qualification"
      }).then(res => {
        this.qualificationList = res;
      });
    },
    back() {
      this.$router.push("/serviceProviderList");
    },
    /* 获取当前登录企业的信息 */
    getCurrentInfo() {
      getCurrentInfo().then(res => {
        if (res && Object.keys(res).length > 0) {
          if(!this.$route.query.uuid) {
            this.form.unitName = res.name;
            this.form.creditCode = res.creditCode;
            this.form.address = res.fullAddress;
            this.form.establishTime = res.registeredDate;
            this.form.registerMoney = res.registeredCapital;
            // this.form.mainBusiness = res.products;
            this.form.regionValue = res.areaList;
            this.form.type = res.enterpriseTypeName;
            // this.form.companyProvice = res.areaList[0];
            // this.form.companyCity = res.areaList[1];
            // this.form.companyArea = res.areaList[2];
            this.form.companyCode = res.creditCode;
            this.form.contact = res.contact;
            this.form.legalPerson = res.corporation;
            this.form.email = res.contactMail;
            this.form.telPhone = res.contactTel;
          }
          this.licenseUrl = res.licenseUrl;
        } else {
          this.form = { ...form(),...this.form};
        }
      });
    },
    onClickStep(index) {
      if (this.disabled) {
        // 如果当前为审核中或者审核通过的状态
        this.activeStep = index + 1;
      }
      // this.activeStep = index + 1
      // if (this.activeStep++ > 3) this.activeStep = 0;
    },
    /* 获取申报企业基本信息详情 */
    getServiceProviderCompanyInfo(uuid) {
      getServiceProviderCompanyInfo({uuid}).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = {...res.data,qualificationType: res.data.qualificationType.split(','),serviceIndustryDetail: res.data.serviceIndustryDetail.split(','),serviceIndustry: res.data.serviceIndustry.split(',')}
          setTimeout(() => {
            this.serviceEnterpriseInfoList = this.form.serviceEnterpriseInfoList;
          },200)
          this.getRegion();
          this.disabled =
            this.$route.query.status == "1" ||
            this.$route.query.status == "4"
              ? false
              : true;
          this.showFile1 = true;
          this.showFile2 = true;
          this.verifyFlowPath(this.form.uuid);
        } else {
          this.form = form();
        }
      });
    },
    /* 下一步，保存 */
    save() {
      if (
        this.$route.query.status &&
        this.$route.query.status !== "1" &&
        this.$route.query.status !== "4"
      ) {
        //如果该条状态 不为 申报中 或者 审核不通过，则点下一步时不用保存，即只能查看详情
        this.activeStep++;
      } else if (
        !this.$route.query.status ||
        this.$route.query.status == "1" ||
        this.$route.query.status == "4"
      ) {
        // 如果该条状态为第一次填报 或者 申报中状态 或者 审核不通过状态，则点下一步时需要保存
        switch (this.activeStep) {
          case 1:
            this.firstSave();
            break;
          case 2:
            this.secondSave();
            break;
          case 3:
            this.thirdSave();
            break;
          case 4:
            this.fourthSave();
            break;
            case 5:
            this.fifthSave();
            break;
        }
      }
    },
   /* 第一步申报企业基本信息保存 */
    firstSave() {
      console.log("this.form=", this.form);
      // if (this.form.evaluate==''){
      //   this.$message({
      //     message: "传智能制造诊断评估报告",
      //     type: "error"
      //   });
      //   return;
      // }
      // if (this.form.fusion==''){
      //   this.$message({
      //     message: "上传两化融合诊断评估报告",
      //     type: "error"
      //   });
      //   return;
      // }
      console.log("111",this.serviceEnterpriseInfoList)

      // 校验表格中的必填字段
      let tableValid = true;
      const errorMsgs = [];

      // 校验技术能力表格字段
      console.log("必输校验？？", this.form.employeeNum, !this.form.employeeNum,this.form.employeeNum !== 0);
      if (!this.form.employeeNum && this.form.employeeNum !== 0) {
        tableValid = false;
        errorMsgs.push("企业员工总数不能为空");
      }
      if (!this.form.rdNum && this.form.rdNum !== 0) {
        tableValid = false;
        errorMsgs.push("研发人数不能为空");
      }
      if (!this.form.masterNum && this.form.masterNum !== 0) {
        tableValid = false;
        errorMsgs.push("硕士人数不能为空");
      }
      if (!this.form.doctorNum && this.form.doctorNum !== 0) {
        tableValid = false;
        errorMsgs.push("博士人数不能为空");
      }
      if (!this.form.middleTitleNum && this.form.middleTitleNum !== 0) {
        tableValid = false;
        errorMsgs.push("中级职称人数不能为空");
      }
      if (!this.form.highTitleNum && this.form.highTitleNum !== 0) {
        tableValid = false;
        errorMsgs.push("高级职称人数不能为空");
      }

      // 校验专利和著作权表格字段
      if (!this.form.patentNum && this.form.patentNum !== 0) {
        tableValid = false;
        errorMsgs.push("核心业务领域专利累计授权不能为空");
      }
      if (!this.form.inventionNum && this.form.inventionNum !== 0) {
        tableValid = false;
        errorMsgs.push("发明专利数不能为空");
      }
      if (!this.form.softwareNum && this.form.softwareNum !== 0) {
        tableValid = false;
        errorMsgs.push("核心业务领域计算机软件著作权累计登记不能为空");
      }

      // 校验标准制定表格字段
      if (!this.form.nationalStandardNum && this.form.nationalStandardNum !== 0) {
        tableValid = false;
        errorMsgs.push("参与制定的数字化转型领域国家标准不能为空");
      }
      if (!this.form.industryStandardNum && this.form.industryStandardNum !== 0) {
        tableValid = false;
        errorMsgs.push("行业标准数不能为空");
      }
      if (!this.form.groupStandardNum && this.form.groupStandardNum !== 0) {
        tableValid = false;
        errorMsgs.push("团体标准数不能为空");
      }
      if (!this.form.leadStandardNum && this.form.leadStandardNum !== 0) {
        tableValid = false;
        errorMsgs.push("牵头制定的数字化转型领域国家标准不能为空");
      }
      if (!this.form.industryStandardNumOther && this.form.industryStandardNumOther !== 0) {
        tableValid = false;
        errorMsgs.push("牵头制定的行业标准数不能为空");
      }
      if (!this.form.groupStandardNumOther && this.form.groupStandardNumOther !== 0) {
        tableValid = false;
        errorMsgs.push("牵头制定的团体标准数不能为空");
      }
      if (!this.form.qualificationType || this.form.qualificationType.length === 0) {
        tableValid = false;
        errorMsgs.push("资质类型不能为空");
      }

      // 校验动态表格字段（近三年在主要产业开展数字化转型服务企业数量及合同总金额）
      if (this.serviceEnterpriseInfoList && this.serviceEnterpriseInfoList.length > 0) {
        this.serviceEnterpriseInfoList.forEach((item, index) => {
          if (!item.serviceEnterpriseNum && item.serviceEnterpriseNum !== 0) {
            tableValid = false;
            errorMsgs.push(`第${index + 1}行服务企业数量不能为空`);
          }
          if (!item.serviceNxEnterpriseNum && item.serviceNxEnterpriseNum !== 0) {
            tableValid = false;
            errorMsgs.push(`第${index + 1}行服务宁夏企业数量不能为空`);
          }
          if (!item.contractMoney && item.contractMoney !== 0) {
            tableValid = false;
            errorMsgs.push(`第${index + 1}行合同总金额不能为空`);
          }
          if (!item.serviceNxContractMoney && item.serviceNxContractMoney !== 0) {
            tableValid = false;
            errorMsgs.push(`第${index + 1}行宁夏企业合同总金额不能为空`);
          }
        });
      }

      // 如果表格校验不通过，显示错误信息
      if (!tableValid) {
          this.$message({
            message: errorMsgs.join("\n"),
            type: "error"
          });
        return;
      }

      const param = {...this.form,serviceEnterpriseInfoList: this.serviceEnterpriseInfoList,qualificationType: this.form.qualificationType.join(','),serviceIndustryDetail: this.form.serviceIndustryDetail.join(','),serviceIndustry: this.form.serviceIndustry.join(',')}
      this.$refs.form.validate(valid => {
        if (valid) {
          // console.log('***', this.$route.query)
          saveServiceProviderCompanyInfo({
            // policyUuid: this.$route.query.policyUuid,
            userUuid: this.$store.state.isUsermessage.uuid,
            ...param
          }).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data;
              this.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          }).catch(err => {
            this.$message({
              message: "服务器异常，请重试或联系管理员！",
              type: "error"
            });
            console.log("error===========0912",err);
          });
        }
      });
    },

    /* 第二步申报项目基本信息保存 */
    secondSave() {
      this.$refs.secondStep.save();
    },
    /* 第三步平台服务商基本信息 */
    thirdSave() {
      this.$refs.thirdStep.save();
    },
    /* 第四步应用企业基本信息 */
    fourthSave() {
      this.$refs.fourthStep.save("INIT");
    },
    fifthSave() {
      this.$refs.fifthStep.save("save");
    },
    /* 提交 */
    submit() {
      this.$refs.fifthStep.save("submit");
    },
    /* 查看审核流程 */
    verifyFlowPath(uuid) {
      this.flowList = [];
      verifyFlowPath({
        uuid: uuid
      }).then(res => {
        if (res && res.length > 0) {
          res.map(el => {
            if (el.status == "REVIEW_PASS" || el.status == "REJECT") {
              this.flowList.push(el);
            }
          });
        }
      });
    },
    /* 改变省/区/市 */
    changeRegion(val) {
      // console.log(val)
      if (val) {
        this.form.companyProvice = val[0];
        this.form.companyCity = val[1];
        this.form.companyArea = val[2];
      } else {
        this.form.companyProvice = "";
        this.form.companyCity = "";
        this.form.companyArea = "";
      }
    },
    /* 回显省/区/市 */
    getRegion() {
      this.form.regionValue = [
        this.form.companyProvice,
        this.form.companyCity,
        this.form.companyArea
      ];
    },
    beforeAvatarUpload(file) {
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      let fileTypes = [".pdf", ".PDF"];
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      // console.log('fileTypeName:',fileTypeName,'file:',file)
      let fileIndex = fileTypes.indexOf(fileTypeName);
      if (fileIndex === -1) {
        this.$alert("只能上传PDF格式文件", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileIndex !== -1 && fileNameLength;
    },
    handleAvatarSuccess(res, type) {
      // console.log(res, type)
      if (res) {
        if (type == "1") {
          this.form.evaluateName = res.fileName;
          this.form.evaluate = res.url;
          this.showFile1 = false; // 详情原来如果有文件，在新文件上传后去替换掉
        } else {
          this.form.fusionName = res.fileName;
          this.form.fusion = res.url;
          this.showFile2 = false;
        }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        console.log("上传成功：", this.form);
      }
    },
    /* 移除文件 */
    removeFile(res, type) {
      if (type == "1") {
        this.form.evaluateName = "";
        this.form.evaluate = "";
      } else {
        this.form.fusionName = "";
        this.form.fusion = "";
      }
      // console.log('删除', this.form)
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.proReport {
  @import "../../assets/css/common.less";
  position: relative;
  background-color: #f4f4f4;
  padding: 0px 0 20px 0;
  overflow: hidden;
  .center-input {
    text-align: center;

    /deep/ .el-input__inner {
      text-align: center;
    }
  }
  .w150 {
    width: 150px;
  }

  .w300 {
    width: 300px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .title {
    color: @basic-colors;
    width: 1300px;
    margin: 10px auto 10px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: bold;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: @basic-colors;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .back {
      margin-right: 14px;
      cursor: pointer;
    }
  }

  .report {
    width: 1300px;
    min-height: 400px;
    background-color: #ffff;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;

    h4 {
      color: #535353;
      font-size: 14px;
      margin: 20px 0 20px 12px;
      position: relative;

      &::before {
        position: absolute;
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: -12px;
        top: 50%;
        transform: translateY(-50%);
        background-color: @basic-colors;
      }
    }

    .apply-step {
      margin: 20px 0px 20px;

      .stepCur {
        width: 36px;
        height: 36px;
        line-height: 36px;
        border-radius: 50%;
        color: #fff;
        background-color: @basic-colors;
      }
    }

    .apply-form {
      margin: 0 0px;
      min-height: 300px;
      padding-bottom: 30px;
      border-radius: 12px;

      .form-wrap {
        padding: 10px 20px;
        .long-label {
          /deep/ .el-form-item__label {
            line-height: 130% !important;
          }
        }
        .bs();

        p {
          font-size: 14px;
          color: #888888;
          line-height: 1.7;
        }

        .form-title {
          font-size: 14px;
          font-weight: bold;
          margin: 0 0 30px 0px;
          position: relative;
          color: #535353;

          &::before {
            position: absolute;
            content: "";
            width: 4px;
            height: 90%;
            // border-radius: 50%;
            background-color: #2d50a1;
            top: 50%;
            left: -8px;
            transform: translateY(-50%);
          }
        }

        .iploadInput {
          display: inline-flex;
          justify-content: start;
          align-items: center;

          .uploadBtn {
            width: 200px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            box-sizing: border-box;
            font-size: 14px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #dcdfe6 !important;
          }
        }
      }

      .process {
        margin: 0 40px 40px;
        background-color: #fbfbfb;
        border-radius: 5px;
        padding: 20px;
      }

      .btnGroup {
        margin: 0 auto;

        .form-next,
        .form-pre,
        .form-save {
          width: 120px;
          height: 40px;
          .lh(40px);
          .bs();
          .bc();
          .br(4px);
          text-align: center;
          color: #fff;
          cursor: pointer;
          margin: 0 5px;
        }

        .form-pre {
          color: @basic-colors;
          border: 1px solid #2d50a1;
          .bc(15%);
        }

        .form-save {
          background-color: #909399;
          border-color: #909399;
        }
      }
    }
  }

  /* 步骤条样式 */
  /deep/ .el-step__icon.is-text.is-finish {
    border: 2px solid @basic-colors;
  }

  /deep/ .el-step__head.is-finish {
    border-color: @basic-colors;
  }

  /deep/ .el-step__title {
    font-size: 16px;
    line-height: 38px;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    top: -60px;
  }

  /deep/ .el-step.is-center .el-step__description {
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
    color: @basic-colors;
    cursor: pointer;
  }

  /deep/ .el-step__icon {
    width: 36px;
    height: 36px;
    color: @basic-colors;
    cursor: pointer;
  }

  /deep/ .el-step.is-horizontal .el-step__line {
    top: 18px;
  }
  /deep/ .el-step__head.is-process {
    color: #c0c4cc;
    border-color: #c0c4cc;
  }
  /* 上传进度条样式 */
  /deep/ .el-upload-list {
    display: inline-block;
    margin-left: 20px;
  }

  /deep/ .el-upload-list__item:first-child {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/serviceProviderApply.vue